import React, {useEffect, useState} from "react";
import {Box, Button, Input, Modal, Typography, useMediaQuery} from "@mui/material";
import {PageRunsDto, PopupDataDto} from "../../dtos";
import {makeStyles} from "@mui/styles";
import {ClosePopupBtn} from "../../com/closePopupBtn/closePopupBtn";
import {useDispatch} from "react-redux";
import {convertPagesRangeToString} from "../../globals/globFunctions";
import {SimpleConfirmPopup} from "../../com/simpleConfirmPopup/SimpleConfirmPopup";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {createTocForPage, updateToc} from "../../store/actionCreators/tocForPagesActionsCreator";
import {ActionType} from "../../store/actionTypes";

const useStyles = makeStyles(() => ({
    inputStyles: {
        width: `100%`,
        lineHeight: `1`,
        // backgroundColor: '#ffffff',
        border: `1px solid #888888`,
        // border: props.readonly && !props.isMultiplyRows ? `none` : `1px solid #888888`,
        backgroundColor: `white`,
        borderRadius: "5px",
        "&.MuiInputBase-multiline": {
            padding: `0`,
        },
        "&.MuiInput-root": {
            '& > input': {
                padding: "4px 8px"
                // fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
                // padding: props.withoutPadding && props.readonly ? `0` : `6px`,
                // direction: props.direction,
                // color: props.readonly ? `#A2A2A2` : `#000000`,
            },
            '& > textarea': {
                padding: "4px 8px"
                // fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
                // padding: props.withoutPadding && props.readonly ? `0` : `5px`,
                // direction: props.direction,
                // color: props.readonly ? `#A2A2A2` : `#000000`,
            }
        },
        "&.requiredField": {
            borderLeft: `4px solid #E5870E`,
            borderRadius: `0 5px 5px 0`,
        },
        "&.notValid": {
            borderLeftColor: `red`,
        },
        "&.Mui-disabled": {
            backgroundColor: `#dbdbdb`,
        },
    },

}))

interface Props {
    popupData: PopupDataDto;
    closePopup: VoidFunction;
}

interface PopupStateDto {
    caption: string;
    pageNumber: string;
}

export const AddEditToCCaption: React.FC<Props> = ({
                                                       popupData,
                                                       closePopup
                                                   }) => {
    const dispatch = useDispatch();
    const {isOpen, pageTocCaption, pageRange, isNew} = popupData;
    const flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const {tocForPage} = useTypedSelector((state) => state);
    const isSm = useMediaQuery(`(max-width:899px)`);
    const [popupState, setPopupState] = useState<PopupStateDto>({
        caption: pageTocCaption || "",
        pageNumber: ""
    });
    const [popupDefaultState, setPopupDefaultState] = useState<PopupStateDto>({
        caption: pageTocCaption || "",
        pageNumber: ""
    });
    const [isShowConfirmExitPopup, setShowConfirmExitPopup] = useState(false);
    const classes = useStyles();

    useEffect(() => {
        console.log(pageRange);
        const pagesRangeInString = convertPagesRangeToString(popupData.pageRange);
        const data = {
            caption: pageTocCaption || "",
            pageNumber: pagesRangeInString
        }
        setPopupDefaultState(data)
        setPopupState(data);
    }, [popupData]);

    useEffect(() => {
        if(tocForPage.type === ActionType.CREATE_TOC_FOR_PAGE_SUCCESS || tocForPage.type === ActionType.UPDATE_TOC_FOR_PAGE_SUCCESS){
            closePopup();
        }
    }, [tocForPage.type]);


    const onChangeText = (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        const targetName = event.target.name;
        const value = event.target.value;
        if (targetName === "pageNumber") {
            // const re = /^([0-9\b]*\-?,?([0-9\b]*)\-?,?$)/gm;
            const re = /^[0-9\b\-,]+$/;
            if (value === '' || re.test(value)) {
                const pageRange = value.split(',');
                let isPossibleValue = true;
                //checkin in value string include number which more than pages number
                pageRange.forEach((value: string) => {
                    if(value.indexOf("-") > -1){
                        const pagesRange = value.split('-');
                        if(Number(pagesRange[0]) > flyerDetailsState.flyerPages.length || Number(pagesRange[1]) > flyerDetailsState.flyerPages.length ){
                            isPossibleValue = false;
                        }
                    } else {
                        if(Number(value) > flyerDetailsState.flyerPages.length){
                            isPossibleValue = false;
                        }
                    }
                })
                if(isPossibleValue){
                    setPopupState({
                        ...popupState,
                        [targetName]: value,
                    });
                }
            }
        } else {
            setPopupState({
                ...popupState,
                [targetName]: value,
            });
        }
    }

    const validatorForPages = (value: string): boolean => {
        const rex = /^\d+(?:-\d+)?(?:,\d+(?:-\d+)?)*$/;
        return rex.test(value);
    }

    const saveToC = () => {
        const pageRangesArray: PageRunsDto[] = [];
        const pageRange = popupState.pageNumber.split(',');
        pageRange.forEach((value: string) => {
            if(value.indexOf("-") > -1){
                const pagesRange = value.split('-');
                pageRangesArray.push({
                    startPageNo: Number(pagesRange[0]),
                    endPageNo: Number(pagesRange[1])
                })

            } else {
                pageRangesArray.push({
                    startPageNo: Number(value),
                    endPageNo: Number(value)
                })
            }
        })
        if (isNew) {
            const data = {
                flyerId: flyerDetailsState.flyRecId,
                caption: popupState.caption,
                pageRuns: pageRangesArray
            }
            dispatch(createTocForPage(data, flyerDetailsState))
        } else {
            const data = {
                flyerId: flyerDetailsState.flyRecId,
                caption: popupState.caption,
                tocEntryId: popupData.tocEntryId || 0,
                pageRuns: pageRangesArray
            }
            dispatch(updateToc(data, flyerDetailsState))

        }
    }

    const compareDefaultStateAndCurrentState = (): boolean => {
        const stringDefaultState = JSON.stringify(popupState);
        const stringCurrentState = JSON.stringify(popupDefaultState);
        return stringDefaultState === stringCurrentState;
    }

    const checkStatesBeforeLeave = () => {
        const isStateNotChanged = compareDefaultStateAndCurrentState();
        if (isStateNotChanged || !validatorForPages(popupState.pageNumber) || popupState.caption === "") {
            closePopup();
        } else {
            setShowConfirmExitPopup(true);
        }
    }

    return (
        <>
            <Modal open={isOpen} disableScrollLock={true}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isSm ? `90vw` : `25vw`,
                        backgroundColor: `#ffffff`,
                        display: "flex",
                        flexFlow: "column",
                        maxHeight: `90vh`,
                        paddingBottom: `20px`
                    }}
                >
                    <Box>
                        <Box sx={{
                            position: "relative",
                            display: "flex",
                            height: "40px",
                            backgroundColor: "#014780",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <Typography color={"#ffffff"}>
                                {isNew ? "New ToC Entry" : "Edit ToC Entry"}
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: `flex`,
                            justifyContent: `flex-end`,
                            position: "absolute",
                            right: "6px",
                            top: "6px"
                        }}>
                            <ClosePopupBtn onClose={checkStatesBeforeLeave}/>
                        </Box>
                    </Box>
                    <Box sx={{
                        padding: "20px",
                        display: "flex",
                        flexFlow: "column",
                        rowGap: "32px",
                    }}>
                        <Box
                            sx={{
                                display: "flex",
                                flexFlow: "column",
                                rowGap: "4px"
                            }}
                        >
                            <Typography>
                                Table of Content Caption
                            </Typography>
                            <Input
                                {...(isSm ? {multiline: true} : {})}
                                className={`${classes.inputStyles} requiredField ${popupState.caption === "" ? 'notValid' : ''}`}
                                disableUnderline
                                onChange={onChangeText}
                                value={popupState.caption}
                                name={"caption"}
                                rows={isSm ? 2 : 1}
                            />
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexFlow: "column",
                                rowGap: "4px"
                            }}>
                            <Typography>
                                Page Number
                            </Typography>
                            <Input
                                className={`${classes.inputStyles} requiredField ${!validatorForPages(popupState.pageNumber) ? 'notValid' : ''}`}
                                disableUnderline
                                onChange={onChangeText}
                                value={popupState.pageNumber}
                                name={"pageNumber"}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            padding: "0 20px"
                        }}
                    >
                        <Button
                            disabled={!validatorForPages(popupState.pageNumber) || popupState.caption === "" || compareDefaultStateAndCurrentState()}
                            onClick={saveToC}
                            sx={{
                                width: `100%`,
                                color: `initial`,
                                background: `#014780`,
                                // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
                                height: `40px`,
                                borderRadius: `0`,
                                margin: "0",
                                '&:hover': {
                                    background: `#014780`,
                                    opacity: `0.7`
                                },
                                '&:disabled': {
                                    opacity: `0.5`
                                }
                            }}
                        >
                            <Typography color={"#ffffff"}>
                                Save
                            </Typography>
                        </Button>
                    </Box>
                </Box>
            </Modal>
            {isShowConfirmExitPopup && (
                <SimpleConfirmPopup
                    onClose={setShowConfirmExitPopup}
                    contentText={`Save changes?`}
                    onConfirm={saveToC}
                    buttonText={[`Save`, `Don't Save`, `Cancel`]}
                    onCloseWithoutSaving={closePopup}
                />
            )}
        </>
    )
}